import styled from 'styled-components';
import { DefaultButton } from '../../../../../styles/globals';
import { ITheme, IThemeProvider } from '../../../../../styles/theme';

interface ICardNavButton {
  theme: ITheme;
  active?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.secondary[70]};
    border-radius: ${theme.layout.spacing.nano};
    height: ${theme.layout.spacing.deka};
  `}
`;

export const CardButtonsCont = styled.div`
  position: relative;
  height: 100%;
  border-radius: 6px;
`;

export const CardNavButton = styled(DefaultButton)<ICardNavButton>`
  text-transform: capitalize;
  height: 100%;
  border: 0;
  width: auto;
  transition: 0.3s;
  font-size: 14px;

  ${({ theme, active }: ICardNavButton) => `
  border-radius: ${theme.layout.spacing.piko};
    padding: 0 ${theme.layout.spacing.decy};
    background: ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[0]};
    color: ${active ? theme.colors.neutral.primary[0] : theme.colors.secondary[100]};
    font-weight: 400;
  `}
`;
